<ion-header mode="ios"
  [ngClass]="{'customHeader': show == 'true', 'colorWhite': color == 'true', 'backButtonRemove': buttonHiden == 'true'}">
  <ion-toolbar mode="ios">
    <ion-buttons mode="ios" slot="start">
      <ion-button mode="ios" (click)="onBackButtonFunc()">
        <ion-icon mode="ios" class="ca-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title mode="ios">{{backPage}}</ion-title>
  </ion-toolbar>
</ion-header>